const IMAGE_ACCEPT = 'image/jpeg,image/jpg,image/png';

// video/* covers formats the browser recognizes; the explicit extensions catch containers it
// leaves with an empty MIME type (e.g. .mkv) so they still pass accept.
const VIDEO_ACCEPT = 'video/*,.mp4,.mov,.avi,.wmv,.mkv,.flv,.mpeg,.3gp';

// Accepted media formats for the sequence upload drop zone. Video is only offered to clients
// whose isLongVideoEnabled flag is on, otherwise picking one would fail server-side.
export const getDropZoneAcceptValidator = (isLongVideoEnabled: boolean): string =>
  isLongVideoEnabled ? `${IMAGE_ACCEPT},${VIDEO_ACCEPT}` : IMAGE_ACCEPT;
